import styled from "styled-components";

const StyledContainer = styled.div`
  overflow: auto;
  padding: 16px 32px 32px;
  width: 1248px;

  .ant-breadcrumb {
    margin-bottom: 16px;
  }

  main {
    width: 100%;

    h2 {
      border: 1px solid #c9c8c8;
      border-radius: 8px;
      color: #4b4747;
      font-size: 18px;
      font-weight: 300;
      line-height: 110%;
      margin: unset;
      padding: 8px;
      width: 268px;
    }

    .ant-tabs-top > .ant-tabs-nav::before,
    .ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar {
      display: none;
    }

    .ant-tabs {
      > .ant-tabs-nav .ant-tabs-nav-wrap {
        justify-content: center;
      }

      > .ant-tabs-nav .ant-tabs-nav-list {
        background: #b9c6cc;
        border-radius: 23px;
        gap: 4px;
        padding: 6px 8px;
      }

      .ant-tabs-tab {
        margin: unset;
        padding: unset;
      }

      .ant-tabs-tab-btn {
        color: #fff;
        height: fit-content;
        margin: unset;
        padding: 2px 10px;
      }

      .ant-tabs-tab.ant-tabs-tab-active {
        background: #fff;
        border-radius: 23px;
      }
    }

    .ant-table-empty {
      .ant-table-tbody .ant-table-cell {
        padding: unset !important;
        border: unset;
      }

      .ant-empty {
        align-items: center;
        border-radius: 0 0 12px 12px;
        background: #f5f9f9;
        display: flex;
        height: 231px;
        justify-content: center;
        margin: unset;
      }
    }

    h4 {
      color: #1e1919;
      font-size: 19px;
      line-height: 140%;
      margin: 0 0 8px;
    }

    .value-container {
      background: #fbfbfb;
      border: 1px solid #c8e4ff;
      border-radius: 12px;
      color: #1e1919;
      max-width: 232px;
      padding: 16px;

      span {
        line-height: 140%;
      }

      p {
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%;
        margin: 0;
      }
    }

    .highcharts-button-box {
      fill: transparent;
    }

    .highcharts-button-pressed {
      .highcharts-button-box {
        fill: #b9c6cc;
        height: 24px;
      }

      text {
        font-weight: 500 !important;
      }
    }

    .highcharts-range-input text {
      fill: #1e1919 !important;
    }
  }
`;

export default StyledContainer;
